import { Link } from 'react-router-dom'
import { GLOSSARY, glossaryHref } from '@/lib/glossary'
import { Tooltip } from './tooltip'

/** An on-screen glossary term: shows the definition on hover and links to the glossary entry. */
export function Term({ id, children }: { id: string; children?: React.ReactNode }) {
  const entry = GLOSSARY.find((g) => g.id === id)
  if (!entry) return <>{children}</>
  return (
    <Tooltip content={entry.meaning}>
      <Link to={glossaryHref(id)} className="underline decoration-dotted decoration-muted-foreground/60 underline-offset-2 hover:decoration-foreground">
        {children ?? entry.term}
      </Link>
    </Tooltip>
  )
}
